// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"ConsultingService_thecomp__OyB3_"};